export default [
  {
    path: '/:projectId/certificates/',
    component: () => import('@/views/security/certificates/Certificates.vue'),
    name: 'certificates',
    meta: {
      projectRequired: true,
      pageTitle: 'Certificates',
      rule: 'admin',
      breadcrumb: [
        { text: 'Security', disabled: true },
        { text: 'Certificates', active: true },
      ],
      navActiveLink: 'certificates',
    },
  },
  {
    path: '/:projectId/certificates/create',
    component: () => import('@/views/security/certificates/Create.vue'),
    name: 'certificates-create',
    meta: {
      projectRequired: true,
      pageTitle: 'Add Certificate',
      rule: 'admin',
      breadcrumb: [
        { text: 'Security', disabled: true },
        { text: 'Certificates', route: 'certificates' },
        { text: 'Add Certificate', active: true },
      ],
      navActiveLink: 'certificates',
      redirectTo: 'certificates',
    },
  },
  {
    path: '/:projectId/certificates/request',
    component: () => import('@/views/security/certificates/Request.vue'),
    name: 'certificates-request',
    meta: {
      projectRequired: true,
      pageTitle: 'Request Certificate',
      rule: 'admin',
      breadcrumb: [
        { text: 'Security', disabled: true },
        { text: 'Certificates', route: 'certificates' },
        { text: 'Request Certificate', active: true },
      ],
      navActiveLink: 'certificates',
      redirectTo: 'certificates',
    },
  },
  {
    path: '/:projectId/certificates/validate/:certificateId',
    component: () => import('@/views/security/certificates/Validate.vue'),
    name: 'certificates-validate',
    meta: {
      projectRequired: true,
      pageTitle: 'Certificate',
      rule: 'admin',
      breadcrumb: [
        { text: 'Security', disabled: true },
        { text: 'Certificates', route: 'certificates' },
        { text: 'Validate Certificate', active: true },
      ],
      navActiveLink: 'certificates',
      redirectTo: 'certificates',
    },
  },
  {
    path: '/:projectId/certificates/:certificateId',
    component: () => import('@/views/security/certificates/View.vue'),
    name: 'certificates-view',
    meta: {
      projectRequired: true,
      pageTitle: 'Certificate Info',
      rule: 'admin',
      breadcrumb: [
        { text: 'Security', disabled: true },
        { text: 'Certificates', route: 'certificates' },
        { text: 'Certificate Info', active: true },
      ],
      navActiveLink: 'certificates',
      redirectTo: 'certificates',
    },
  },
  {
    path: '/:projectId/api-keys',
    component: () => import('@/views/security/api-keys/ApiKeysView.vue'),
    name: 'api-keys',
    meta: {
      projectRequired: true,
      pageTitle: 'API Keys',
      rule: 'admin',
      breadcrumb: [
        { text: 'Security', disabled: true },
        { text: 'API Keys', active: true },
      ],
      navActiveLink: 'api-keys',
      redirectTo: 'api-keys',
    },
  },
  {
    path: '/:projectId/api-keys/new',
    name: 'new-api-key',
    component: () => import('@/views/security/api-keys/ApiKeyNew.vue'),
    meta: {
      projectRequired: true,
      pageTitle: 'Create API Key',
      breadcrumb: [
        { text: 'Security', disabled: true },
        { text: 'API Keys', route: 'api-keys' },
        { text: 'Create API Key', active: true },
      ],
      navActiveLink: 'api-keys',
      redirectTo: 'api-keys',
    },
  },
  {
    path: '/:projectId/api-keys/:id',
    name: 'view-api-key',
    component: () => import('@/views/security/api-keys/ApiKeyView.vue'),
    meta: {
      projectRequired: true,
      pageTitle: 'View API Key',
      breadcrumb: [
        { text: 'Security', disabled: true },
        { text: 'API Keys', route: 'api-keys' },
        { text: 'View API Key', active: true },
      ],
      navActiveLink: 'api-keys',
      redirectTo: 'api-keys',
    },
  },
  {
    path: '/:projectId/api-keys/:id/edit',
    name: 'edit-api-key',
    component: () => import('@/views/security/api-keys/ApiKeyEdit.vue'),
    meta: {
      projectRequired: true,
      pageTitle: 'Update API Key',
      breadcrumb: [
        { text: 'Security', disabled: true },
        { text: 'API Keys', route: 'api-keys' },
        { text: 'Update API Key', active: true },
      ],
      navActiveLink: 'api-keys',
      redirectTo: 'api-keys',
    },
  },

]
